'use client';

import dynamic from 'next/dynamic';

/**
 * WebMCP is for agents, not for the reader's first paint. `ssr: false` keeps the
 * tool registry and its zod dependency out of the server render and out of the
 * initial JS payload; the surface attaches after hydration, which is soon enough
 * for an agent inspecting the page and invisible to a human.
 */
const WorkadabraWebMcpSurface = dynamic(() => import('Workadabra/lib/webmcp/provider-shell').then(m => m.WorkadabraWebMcpSurface), { ssr: false });

export const WebMcpMount = () => <WorkadabraWebMcpSurface />;
